
import React from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import { useAboutMeImages } from "./about-me/useAboutMeImages";
import AboutMeIntro from "./about-me/AboutMeIntro";
import MobileCategories from "./about-me/MobileCategories";
import DesktopCategories from "./about-me/DesktopCategories";

const NewSectionSix = () => {
  const isMobile = useIsMobile();
  const { bannerImageUrl, preachingImageUrl, passionsImageUrl } = useAboutMeImages();

  return (
    <div className="relative" id="ns6">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/20 to-black/50" />
      <div className="relative bg-gradient-to-r from-[#243949] to-[#517fa4] [&>*]:relative">
        <div className="container mx-auto px-4 py-8 md:py-16">
          <h3 className="text-lg md:text-xl font-bold text-white mb-8 text-center uppercase">
            Über Mich
          </h3>
          
          <AboutMeIntro 
            imageUrl={bannerImageUrl} 
            isMobile={isMobile} 
            section="about-me-banner"
          />

          {/* Categories section - use appropriate component based on screen size */}
          {isMobile ? (
            <MobileCategories 
              preachingImageUrl={preachingImageUrl} 
              passionsImageUrl={passionsImageUrl} 
            />
          ) : (
            <DesktopCategories 
              preachingImageUrl={preachingImageUrl} 
              passionsImageUrl={passionsImageUrl} 
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default NewSectionSix;
